import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

export type ComboboxValueProps = ComboboxPrimitive.Value.Props;

const ComboboxValue = (props: ComboboxValueProps) => {
  return <ComboboxPrimitive.Value {...props} />;
};

export default ComboboxValue;
